module.exports = __webpack_public_path__ + "img/slide-home-image-2.cbd0d6f4.png";